import { TrendingUp } from "lucide-react";

const SERP = [
  {
    q: "桃園 親子飯店",
    now: ["Trip.com｜桃園親子飯店攻略", "FunTime｜桃園親子飯店推薦", "Vivian 部落格｜桃園親子飯店", "熊貓魚旅遊｜桃園親子飯店", "滿分小姐｜桃園飯店推薦"],
  },
  {
    q: "桃園 飯店",
    now: ["Booking.com｜桃園飯店", "KAYAK｜桃園飯店", "trivago｜桃園飯店", "桃園觀光旅遊網｜推薦住宿", "桃園凱悅／喜來登 官網"],
  },
  {
    q: "桃園 公司團建",
    status: "名人堂官網：未進入第一頁，團建搜尋幾乎看不到名人堂",
    up: "名人堂團建方案頁 排名往前",
    now: ["桃園青年體驗學習園區｜企業訓練", "樂點創意｜企業團建活動", "瘋戶外｜ESG 團建規劃", "閃動格子 CyberCube｜企業包場", "天成逸旅 朋趣豪華露營｜企業員旅"],
  },
];

const Card = ({ s, i }) => (
  <div data-testid={`seo-serp-${i}`} className="rounded-3xl border border-[var(--line)] bg-white p-6">
    <p className="text-sm text-[var(--muted)]">Google 搜尋</p>
    <p className="mt-1 rounded-full border border-[#dfe1e5] px-4 py-2 text-sm font-bold text-[#202124]">{s.q}</p>
    <div className="mt-4 grid grid-cols-2 gap-4">
      <div>
        <p className="text-xs font-black text-[var(--muted)]">現在</p>
        <ol className="mt-2 space-y-1.5 text-xs text-[var(--text)]">
          {s.now.map((r, n) => <li key={r}>{n + 1}. {r}</li>)}
        </ol>
        <p className="mt-3 rounded-lg bg-[var(--warm)] px-2 py-1.5 text-xs font-bold text-[var(--muted)]">{s.status || "名人堂官網：未進入第一頁，只在別人的文章裡被提到"}</p>
      </div>
      <div>
        <p className="text-xs font-black text-[var(--teal-d)]">SEO 優化後（預期）</p>
        <ol className="mt-2 space-y-1.5 text-xs text-[var(--text)]">
          <li className="rounded-lg bg-[#47BBBC]/15 px-2 py-1 font-black text-[var(--teal-d)]">↑ {s.up || "名人堂官網／人客多專案頁 排名往前"}</li>
          {s.now.slice(0, 4).map((r, n) => <li key={r} className="opacity-60">{n + 2}. {r}</li>)}
        </ol>
      </div>
    </div>
  </div>
);

export const SeoBlock = () => (
  <div>
    <p className="mt-3 text-[var(--text)]">我們會做 SEO 優化，讓名人堂官網在 Google 排名往前，客人不用經過訂房網站，直接找到官網訂房。</p>
    <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {SERP.map((s, i) => <Card key={s.q} s={s} i={i} />)}
    </div>
    <p data-testid="seo-future-note" className="mt-4 flex items-start gap-2 text-sm font-bold text-[var(--teal-d)]">
      <TrendingUp size={16} className="mt-0.5 shrink-0" /> 這是附加效益，不計入上面的金額；SEO 優化可以是之後的合作內容。
    </p>
    <p className="mt-1 text-xs text-[var(--muted)]">「現在」依 2026 年 6 月公開搜尋結果整理，實際排名會因裝置、地區和個人搜尋紀錄而不同。</p>
  </div>
);
